export default __webpack_public_path__ + "static/media/EM0333.34I-41688_-24980_0.ced15b3b.jpg";